// import Book1Img from '../image/crown.png';
import { useEffect } from 'react';

// export default function Checkout(){

//     const loadScript = (src) => {
//         return new Promise((resolve) => {
//           const script = document.createElement("script");
//           script.src = src;
//           script.onload = () => {
//             resolve(true);
//           };
//           script.onerror = () => {
//             resolve(false);
//           };
//         document.body.appendChild(script);
//       });
//     };
  
//     useEffect(() => {
//         loadScript("https://checkout.razorpay.com/v1/checkout.js");
//     });


//     function makePayment(e, price, product_name, plan_id){

//         e.preventDefault();


//         let formData = new FormData();
//         formData.append('price', price);
//         formData.append('product_name', product_name);
//         formData.append('plan_id', plan_id);

//         async function paymentGateway() {
//             const authToken = localStorage.getItem('access');
//             const url = 'https://resumeapi.hirebeen.com/new-subscription' // <<< new-subscription backend api url path
//             const res = await fetch(url, { method: 'POST',
//                 headers: {
//                     'Authorization': `Bearer ${authToken}`
//                   },
//                 body: formData , 
//             })
//             const jsonRes = await res.json()
//             return jsonRes
//         }

//         paymentGateway().then((res) =>{
//             //_________ call razorpay gateway ________
//             var options = {
//                 "key": res['razorpay_key'],
//                 "amount": res['order']['amount'],
//                 "currency": res['order']['currency'],
//                 "callback_url": res['callback_url'],
//                 prefill: {
//                     "email": "nosob88243@xitudy.com",
//                     "contact": "1234567890"
//                 },
//                 "name": res['product_name'],
//                 "subscription_id": res['order']['id'],
//             };
  
//             var rzp1 = new window.Razorpay(options);
//             rzp1.open();
//         })
        
//     }


//     return(
//         <>
//             <section className='flex justify-center mt-52'>
//                 <div className='px-10 py-5 text-center rounded drop-shadow-xl bg-zinc-50'>
//                     <h2 className='mb-10 text-3xl'>Monthly Subscription</h2>
//                     <img className='w-48 mx-auto' src={Book1Img} alt="" />
//                     <p className='mt-5 text-lg'>Price : ₹ 599</p>
//                     <button type='button' className="mt-2 mb-2 inline-flex items-center px-2.5 py-1.5 border border-transparent text-lg font-medium rounded shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
//                      onClick={e=>{makePayment(e, 1, "Pro Monthly", "plan_ON2Oqk9C1oFWlq")}}
//                      >Proceed to Buy</button>
//                 </div>
//             </section>
//         </>
//     )
// }







import * as React from "react";
import RazorpayLogo from '../image/razorpay.png';
import SecureLogo from '../image/secure_pay.png'
import SuccessImg from '../image/success.png'
import { API_URL } from '../apiConfig';
import { useSearchParams, useNavigate } from 'react-router-dom';


type StarIconProps = {
  className?: string;
};

const StarIcon: React.FC<StarIconProps> = ({ className }) => (
  <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/43f573f5d9db6e1353696755d708dfd08de049fa862bd1d5e86e7456ae1faf92?apiKey=44137d5b582349c982f95e568cecc6d3&" className={`w-5 aspect-square ${className}`} alt="" />
);

type FeatureItemProps = {
  text: string;
};

const FeatureItem: React.FC<FeatureItemProps> = ({ text }) => (
  <div className="flex gap-1 mt-1">
    <StarIcon />
    <div className="flex-auto text-lg text-black">{text}</div>
  </div>
);

type BillingDetailProps = {
  label: string;
  value: string;
};

const BillingDetail: React.FC<BillingDetailProps> = ({ label, value }) => (
  <>
    <div className="mt-1 text-lg">{label}</div>
    <div className="mt-[-3px] text-lg text-black">{value}</div>
  </>
);

const Checkout: React.FC = () => {
    
    const [userData, setUserData] = React.useState(null);
    const [planData, setPlanData] = React.useState(null);
    const [showPopup, setShowPopup] = React.useState(false);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const subscriptionId = searchParams.get('subscription_id');
    const status = searchParams.get('status');
    const planId = searchParams.get('plan_id');
    const amount = searchParams.get('amount');
    const plan_name = searchParams.get('plan_name');
    const features = [
        "Unlimited resumes and cover letters",
        "All resume templates",
        "Real-time content suggestions",
        "ATS check (Applicant Tracking System)",
        "Pro resume sections",
        "No branding",
        "Unlimited section items",
        "Thousands of design options"
    ];

  const billingDetails = [
    { label: "Name", value: "Umesh Lodha" },
    { label: "Phone", value: "9082123456" },
    { label: "Email", value: "admin@gmail.com" }
  ];

      const loadScript = (src) => {
        return new Promise((resolve) => {
          const script = document.createElement("script");
          script.src = src;
          script.onload = () => {
            resolve(true);
          };
          script.onerror = () => {
            resolve(false);
          };
        document.body.appendChild(script);
      });
    };
  
    useEffect(() => {
        loadScript("https://checkout.razorpay.com/v1/checkout.js");
    });

    React.useEffect(() => {
        if (status) {
          setShowPopup(true);
        }
      }, [status]);


    function makePayment(e, price, product_name, plan_id,plan_duration){

        e.preventDefault();


        let formData = new FormData();
        formData.append('price', price);
        formData.append('product_name', product_name);
        formData.append('plan_id', plan_id);
        formData.append('plan_duration',plan_duration)

        async function paymentGateway() {
            const authToken = localStorage.getItem('access');
            const url = 'https://resumeapi.hirebeen.com/new-subscription' // <<< new-subscription backend api url path
            const res = await fetch(url, { method: 'POST',
                headers: {
                    'Authorization': `Bearer ${authToken}`
                  },
                body: formData , 
            })
            const jsonRes = await res.json()
            return jsonRes
        }

        paymentGateway().then((res) =>{
            //_________ call razorpay gateway ________
            var options = {
                "key": res['razorpay_key'],
                "amount": res['order']['amount'],
                "currency": res['order']['currency'],
                "callback_url": res['callback_url'],
                prefill: {
                    "email": userData.email,
                    "contact": userData.phone
                },
                "name": res['product_name'],
                "subscription_id": res['order']['id'],
            };
  
            var rzp1 = new window.Razorpay(options);
            rzp1.open();
        })
        
    }


  useEffect(() => {
    // Fetch user and plan details from your API
    const fetchCheckoutData = async () => {
      const authToken = localStorage.getItem('access');
      const url = `${API_URL}/user-checkout/?plan_id=`+planId;  // Replace with your actual API endpoint
      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${authToken}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setUserData(data.user);
        setPlanData(data.plan);
      } else {
        console.error('Failed to fetch user and plan details');
      }
    };

    fetchCheckoutData();
  }, []);

  const billerDetails = userData ? [
    { label: "Name", value: userData.first_name },
    { label: "Phone", value: userData.phone },
    { label: "Email", value: userData.email }
  ] : [];

  return (
    <main className="pl-8 bg-white max-md:pl-5">
        {showPopup && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
          <div className="p-6 text-center bg-white rounded-lg shadow-lg">
            {status === 'success' ? (
                
              <div>
                <div className="relative flex items-center justify-center w-24 h-24 mx-auto mb-4 rounded-full">
                  <img src={SuccessImg} alt="" />
                </div>
                {/* <h1 className="mb-2 text-2xl font-semibold"></h1> */}
                <h2 className="mb-2 text-xl">Thank you Payment Complete</h2>
                <p>Transaction ID: {subscriptionId}</p>
                <div className="bg-[#f8f6f6] p-2 px-4 my-4 text-left">
                <p className="text-sm">Plan : {plan_name}</p>
                <p className="text-sm">Amount : ₹{amount}</p>
                </div>
                <button className="px-4 py-2 text-white bg-teal-800 rounded-lg" onClick={() => navigate('/dashboard')}>
                  Go to Dashboard
                </button>
              </div>
            ) : (
                <div>
                <h2 className="mb-4 text-xl">There was an issue with your payment</h2>
                <button className="px-4 py-2 text-white bg-gray-800 rounded-lg" onClick={() => setShowPopup(null)}>
                  Try Again
                </button>
                </div>
            )}
            
          </div>
        </div>
      )}
      <div className="flex gap-5 max-md:flex-col max-md:gap-0">
      {planData &&<section className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
          <div className="flex flex-col mt-6 max-md:mt-10 max-md:max-w-full">
            <div className="max-md:max-w-full">
              <div className="flex gap-5 max-md:flex-col max-md:gap-0">
                <div className="flex flex-col w-[69%] max-md:ml-0 max-md:w-full">
                  <div className="flex flex-col grow max-md:mt-10 max-md:max-w-full">
                    <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/325e707d582ae76401eeef9eb1ec41912bc162e03122e46bb79a3d3e453498e7?apiKey=44137d5b582349c982f95e568cecc6d3&" className="max-w-full aspect-[4.35] w-[180px]" alt="Company logo" />
                     <div className="flex flex-col pl-8 mt-8 max-md:pl-5 max-md:max-w-full">
                      <div className="flex gap-4 text-3xl font-semibold text-black">
                        <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/3da2ce1e329c8acb5bfdc97e566c108eb0569b937b6ec38fbc563f94d7617ec0?apiKey=44137d5b582349c982f95e568cecc6d3&" className="w-10 shrink-0 aspect-square" alt="" />
                        <h1 className="flex-auto my-auto">{planData.plan_name} Plan</h1>
                      </div>
                      <div className="flex gap-1 mt-2 ml-16">
                        {/* <div className="flex flex-col items-center max-md:hidden">
                          {[...Array(8)].map((_, index) => (
                            <StarIcon key={index} className={index > 0 ? "mt-3.5" : ""} />
                          ))}
                        </div> */}
                        <div className="flex-auto">
                          {JSON.parse(planData.plan_description).map((feature, index) => (
                            <FeatureItem key={index} text={feature} />
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col ml-5 w-[31%] max-md:ml-0 max-md:w-full">
                  <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/2752a02f081ccbad0485fab4d432fab3c65f969416c07d57400bb635697e1716?apiKey=44137d5b582349c982f95e568cecc6d3&" className="shrink-0 mt-28 max-w-full aspect-[0.83] w-[170px] max-md:mt-10" alt="Decorative image" />
                </div>
              </div>
            </div>
            <footer className="flex flex-col px-8 mt-12 max-md:px-5 max-md:mt-10 max-md:max-w-full">
              <hr className="shrink-0 max-w-full h-0.5 border-2 border-solid bg-neutral-200 border-neutral-200 w-[620px]" />
              <div className="flex gap-3 mt-7 mr-5 max-md:flex-wrap max-md:mr-2.5">
                <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/dd666a2442c34c3084f20ab0874c7d9883fe3a9a049115af9635ea74569012c3?apiKey=44137d5b582349c982f95e568cecc6d3&" className="shrink-0 my-auto max-w-full aspect-[2.5] w-[100px]" alt="Payment method logo" />
                <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/TEMP/4b23531e0b0627ed81592122002cc948d73bfc38a675b99bb501905f6227e9d9?apiKey=44137d5b582349c982f95e568cecc6d3&" className="grow shrink-0 aspect-[7.14] basis-0 w-[80px]" alt="Payment security badges" />
              </div>
              <p className="ml-4 mt-11 text-md text-neutral-500 max-md:mt-10 max-md:max-w-full">
                You consent to be billed and start your {planData.plan_name} subscription today. If you do not cancel before the end of the subscription period, you will automatically be charged the subscription fee of ₹{planData.plan_price}, billed every month until you cancel.
              </p>
              <p className="self-start mt-28 ml-4 text-lg text-neutral-500 max-md:mt-10 max-md:ml-2.5">
                ©2024 Hirebeen. All rights reserved
              </p>
            </footer>
          </div>
        </section>}
        {userData && <section className="flex flex-col w-6/12 ml-9 max-md:ml-0 max-md:w-full">
        
          <div className="flex flex-col w-full py-16 pl-12 pr-16 font-semibold grow bg-zinc-100 max-md:px-5 max-md:mt-10 max-md:max-w-full">
            <div className="flex self-start justify-between gap-3">
              <div className="flex flex-col text-2xl text-white whitespace-nowrap">
                <div className="justify-center items-center text-sm px-[10px] py-1 w-fit bg-orange-500 rounded-full">
                  1
                </div>
                <div className="shrink-0 self-center mt-3 w-[2px] bg-black border border-black border-solid h-[200px]"></div>
              </div>
              <div className="flex flex-col">
                <h2 className="text-2xl mt-[-3px] text-black">Billing Details</h2>
                <div className="flex flex-col pl-4 mt-3 text-xl text-neutral-400">
                  {billerDetails.map((detail, index) => (
                    <BillingDetail key={index} label={detail.label} value={detail.value} />
                  ))}
                </div>
              </div>
            </div>
            <div className="flex self-start gap-3 mt-3">
            <div className="flex flex-col text-white whitespace-nowrap">
                <div className="justify-center items-center text-sm px-[10px] mb-1 py-1 w-fit bg-zinc-900 rounded-full">
                  2
                </div>
              </div>
              <h2 className="text-2xl mt-[-3px] text-black">Payment Summary</h2>
            </div>
            <div class="svg-container" className=" flex ml-[12px] w-[250px] h-[350px]">
            <svg width="250" height="250" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 10 V160 C0 220 60 220 60 220 H150" stroke="grey" stroke-width="2" fill="none"/>
            </svg>

                <div className="absolute z-10 mx-10 mt-2 w-[400px] h-fit">
                    <div className="flex flex-col gap-2 bg-white mt-2 rounded-xl px-4 py-3 w-[400px] h-fit">
                        <div className="flex justify-between w-full text-2xl text-black">
                            <p className="text-base text-gray-500">{planData.plan_name}</p>
                            <p className="text-base text-gray-500">{planData.plan_duration} x INR {planData.plan_price - Math.round(planData.plan_price - (planData.plan_price / (1 + 0.18)))}</p>
                        </div>
                        <div className="flex justify-between w-full text-2xl text-black">
                            <p className="text-base text-gray-500">Tax</p>
                            <p className="text-base text-gray-500">INR {Math.round(planData.plan_price - (planData.plan_price / (1 + 0.18)))}</p>
                        </div>
                        <hr className="h-[2px]"/>
                        <div className="flex justify-between w-full text-2xl text-black">
                            <p className="text-base text-gray-500">Total Billed Now</p>
                            <p className="text-base text-gray-500">INR {planData.plan_price}</p>
                        </div>
                    </div>
                    <p className="mt-1 ml-1 text-sm text-gray-500">
                        *Further, INR {planData.plan_price} will be charged every month
                    </p>
                    <div className="flex justify-center w-full">
                    <button className="justify-center items-center px-16 py-2.5 mt-6 text-xl w-[370px] text-white bg-teal-800 rounded-2xl" onClick={e=>{makePayment(e, planData.plan_price, "Pro Monthly", planId, planData.plan_duration)}}>
                        Pay and Upgrade
                    </button>
                    </div>
                    <div className="flex justify-center gap-4 mt-3 text-base text-black">
                    <img className='w-24' src={SecureLogo} alt="" />
                    <img className='w-24' src={RazorpayLogo} alt="" />
                    </div>
                </div>
                </div>
            
          </div>
        </section>}
      </div>
    </main>
  );
};

export default Checkout;











// import React, { useState } from 'react';
// import axios from 'axios';
// import { API_URL } from '../apiConfig';

// const Checkout = () => {
//     const [selectedPlan, setSelectedPlan] = useState(null);

//     // Dummy plan for testing
//     const dummyPlan = {
//         id: 'plan_ON2Oqk9C1oFWlq',
//         name: 'Pro Monthly',
//         price: 599,
//     };

//     const handleSubscribe = async () => {
//         if (!selectedPlan) return;

//         try {
//             const response = await axios.post(`http://127.0.0.1:8000/new-subscription`, {
//                 plan_id: selectedPlan.id,
//                 price: selectedPlan.price,
//                 product_name: selectedPlan.name,
//             });

//             const { order, razorpay_key, callback_url } = response.data;

//             const options = {
//                 key: razorpay_key,
//                 subscription_id: order.id,
//                 name: selectedPlan.name,
//                 handler: function (response) {
//                     axios.post(callback_url, response)
//                         .then(res => {
//                             console.log(res.data);
//                         })
//                         .catch(err => {
//                             console.error(err);
//                         });
//                 },
//                 prefill: {
//                     name: '',
//                     email: '',
//                     contact: '',
//                 },
//                 notes: {
//                     address: '',
//                 },
//                 theme: {
//                     color: '#F37254',
//                 },
//             };

//             const razorpay = new window.Razorpay(options);
//             razorpay.open();
//         } catch (error) {
//             console.error('Error initiating subscription:', error);
//         }
//     };

//     return (
//         <div>
//             <h2>Choose a Plan</h2>
//             <ul>
//                 <li key={dummyPlan.id}>
//                     <h3>{dummyPlan.name}</h3>
//                     <p>Price: {dummyPlan.price}</p>
//                     <button onClick={() => setSelectedPlan(dummyPlan)}>Select</button>
//                 </li>
//             </ul>
//             <button onClick={handleSubscribe}>Checkout</button>
//         </div>
//     );
// };

// export default Checkout;

